import { FC } from "react";
import clsx from "clsx";
import { useDispatch } from 'react-redux';

import { AppDispatch } from '../../../../redux/reducer/store';

import Select from "../../../custom/select/select";
import CustomMultiSelect from "../../../custom/customMultiSelect/customMultiSelect";

import TextArea from "../../../custom/textArea/TextArea";
import NumberInput from "../../../custom/numberInput/NumberInput";

import styles from '../recruiting.module.scss';

import {
  reducerSingleVacancyStatusMultiSelect, reducerSingleVacancySalary, reducerSingleVacancyIV,reducerSingleVacancyWeekTiming
} from "../../../../redux/reducer/recruiting/reducers/reducerSingleVacancy";
import { actionTest } from "../../../../redux/action/recruiting/actionVacancy";
import { matchingNameMultiselection, matchingNameMultiselectionExt } from "../../../../utils/matchingNameMultiselection";
import { formatHistoryDateTime } from "../../../../utils/formatDate";
import { IVacancyBlocksFormOptions, IVacancyEventItem, ItemEmployeeOptions } from "../../../../types/vacancyInterfeces";
import { Item } from "../../../../types/interfaces";

const VacancyBlock: FC<IVacancyBlocksFormOptions> = ({
  inputValues,
  nameSelect,
  statusName,
  selectChange,
  handleInputChange,
  options,
  data,
  editVacancy,
  scheduleExtSelect,
}) => {
  const dispatch = useDispatch<AppDispatch>();

  const {
    regionsOptions,
    areasOptions,
    contractsOptions,
    supervisorsOptions,
    virtualSupervisorsOptions,
    projectsOptions,
    managersOptions,
    daysOptions
  } = options;

  const resultsupervisors = options.supervisorsOptions && options.supervisorsOptions?.length > 0 
  ? (inputValues?.supervisors || []).map((item: ItemEmployeeOptions) => {
    const foundObject = options.supervisorsOptions.find((obj: { value: number, label: string }) => obj.value === item.employee.id);
    return foundObject || { value: item.employee.id, label: item.employee.name };
  })
  : [];
  const resultsupervisorsExt = matchingNameMultiselectionExt(inputValues?.supervisorsExt || [], supervisorsOptions).filter(Boolean);
  const resultVirtSupervisors = (inputValues?.virtualSupervisors || []).map((item: ItemEmployeeOptions) => {
    const foundObject = options.virtualSupervisorsOptions.find((obj: { value: number, label: string }) => obj.value === item.employee.id);
    return foundObject || { value: item.employee.id, label: item.employee.name };
  }).filter(Boolean);
  const resultVirtSupervisorsExt = matchingNameMultiselectionExt(inputValues?.virtualSupervisorsExt || [], virtualSupervisorsOptions).filter(Boolean);
  const matchingRegions = inputValues.regions && matchingNameMultiselection(inputValues.regions, inputValues?.formData?.regions);
  const matchingRegionsExt = inputValues.regionsExt && matchingNameMultiselectionExt(inputValues.regionsExt, regionsOptions);
  const matchingAreas = inputValues.areas && matchingNameMultiselection(inputValues.areas, inputValues?.formData?.areas);
  const matchingAreasExt = inputValues.areasExt && matchingNameMultiselectionExt(inputValues.areasExt, areasOptions);
  const matchingContracts = inputValues.contracts && matchingNameMultiselection(inputValues.contracts, inputValues?.formData?.contracts);
  const matchingContractsExt = inputValues.contractsExt && matchingNameMultiselectionExt(inputValues.contractsExt, contractsOptions);
  const matchingDays = Array.isArray(inputValues.days) ? inputValues.days?.map((input: { [key: string]: string }) => {
    const val = typeof input === 'object' ? Object.values(input).toString() : input;
    const foundObject = daysOptions.find((obj: { value: string, label: string }) => obj.value === val)
    return foundObject || { value: input, label: Object.values(input) }
  }) : [];
  const matchingDaysExt = Array.isArray(inputValues.daysExt) ? inputValues.daysExt?.map((input: string) => {
    const val = typeof input === 'object' ? Object.values(input).toString() : input;
    const foundObject = daysOptions.find((obj: { value: string, label: string }) => obj.value === val)
    return foundObject || { value: input, label: Object.values(input) }
  }) : [];
  const hour = inputValues.workload && inputValues.workload >= 60 ? inputValues.workload / 60 < 10 ? `0${Math.floor(inputValues.workload / 60)}` : `${Math.floor(inputValues.workload / 60)}` : '00';
  const minuts = inputValues.workload && inputValues.workload > 0 ? inputValues.workload % 60 < 10 ? `0${Math.floor(inputValues.workload % 60)}` : `${Math.floor(inputValues.workload % 60)}` : '00';
  const hourExt = inputValues.workloadExt && inputValues.workloadExt >= 60 ? inputValues.workloadExt / 60 < 10 ? `0${Math.floor(inputValues.workloadExt / 60)}` : `${Math.floor(inputValues.workloadExt / 60)}` : '00';
  const minutsExt = inputValues.workloadExt && inputValues.workloadExt > 0 ? inputValues.workloadExt % 60 < 10 ? `0${Math.floor(inputValues.workloadExt % 60)}` : `${Math.floor(inputValues.workloadExt % 60)}` : '00';
  const matchingProjects = inputValues.projects && matchingNameMultiselection(inputValues.projects, inputValues?.formData?.projects);
  const routesValues = inputValues?.routes && inputValues?.routes.map((el: { project: Item, routes: number[] }) => { return el.routes });

  const handleChangeRoutes = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    if (!/^[0-9,;\s]*$/.test(value)) {
      return;
    }
    dispatch(reducerSingleVacancyIV({ ...inputValues, routesExt: event.target.value }));
  }

  return (
    <div className={styles.vacancy}>
      <div className={styles.section}>
        <div className={clsx(styles.section__container, styles.section__container_left)}>
          <span className='section__title inside'>Описание из маршрута</span>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_right)}>
          <span className='section__title inside'>Проект</span>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_left)}>
          <div className={clsx(
            styles.subBlock,
            styles.filterInput,
            inputValues.type === 'NO_ROUTE' && styles.notVisible
          )}>
            <div className={clsx(styles.subBlock__right, styles.subBlock__right_select)}>
              <Select
                disabled={!editVacancy}
                value={nameSelect}
                propsChange={(event: IVacancyEventItem) =>
                  selectChange(event, 'type')
                }
                options={inputValues?.formData?.types.map((el: { [key: string]: string }[]) => ({
                  value: Object.keys(el),
                  label: Object.values(el),
                }))}
                className={clsx(styles.filterSelect, (data && data?.type?.changed) && styles.changed)}
                placeholder={nameSelect ? nameSelect : 'Выбрать'}
                name='type'
                span='Тип вакансии'
                isShowPlaceholder={true}
              />
            </div>
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_right)}>
          <div className={clsx(
            styles.subBlock,
            styles.filterInput,
            inputValues.type !== 'NO_ROUTE' && styles.notVisible
          )}>
            <div className={clsx(styles.subBlock__right, styles.subBlock__right_select)}>
              <Select
                disabled={!editVacancy}
                value={nameSelect}
                propsChange={(event: IVacancyEventItem) =>
                  selectChange(event, 'type')
                }
                options={inputValues?.formData?.types.map((el: { [key: string]: string }[]) => ({
                  value: Object.keys(el),
                  label: Object.values(el),
                }))}
                className={clsx(styles.filterSelect, (data && data?.type?.changed) && styles.changed)}
                placeholder={nameSelect || 'Выбрать'}
                name='type'
                span='Тип вакансии'
                isShowPlaceholder={true}
              />
            </div>
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_left, styles.wrapperMultiselect)}>
          <div className={clsx(styles.wrapper, inputValues.type !== 'ON_ROUTE' && styles.notVisible)}>
            <div className='reports__region_block-select'>
              <CustomMultiSelect
                setLoading={() => {
                }}
                setState={() => {
                }}
                action={actionTest}
                reducer={reducerSingleVacancyStatusMultiSelect}
                inputValues={inputValues}
                isShowPlaceholder={true}
                placeholder='Проект'
                name='projects'
                pageName='type2'
                options={projectsOptions}
                resetPages={() => {
                }}
                disabled={true}
                visible={inputValues.type === 'NO_ROUTE'}
                activeOptions={inputValues.projects}
              />
            </div>
            {inputValues?.formData &&
              <div className={styles.multiselectContent}>
                <span
                  className={clsx((matchingProjects && matchingProjects.length > 0) && styles.span__elem_active, styles.span__elem, (data && data?.projects?.changed) && styles.changed)}>
                  {matchingProjects && matchingProjects.map((item: Item) => item.name).join(', ')}
                </span>
              </div>
            }
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_right, styles.wrapperMultiselect)}>
          <div className={clsx(styles.wrapper, inputValues.type === 'ON_ROUTE' && styles.notVisible)}>
            <div className='reports__region_block-select'>
              <CustomMultiSelect
                setLoading={() => {
                }}
                setState={() => {
                }}
                action={actionTest}
                reducer={reducerSingleVacancyStatusMultiSelect}
                inputValues={inputValues}
                isShowPlaceholder={true}
                placeholder='Проект'
                name='projects'
                pageName='type2'
                options={projectsOptions}
                resetPages={() => {
                }}
                disabled={!editVacancy}
                visible={inputValues.type === 'ON_ROUTE'}
                activeOptions={inputValues.projects}
              />
            </div>
            {inputValues?.formData &&
              <span
                className={clsx((matchingProjects && matchingProjects.length > 0) && styles.span__elem_active, styles.span__elem, (data && data?.projects?.changed) && styles.changed)}>
                {matchingProjects && matchingProjects.map((item: Item) => item.name).join(', ')}
              </span>}
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_left)}>
          <div className={clsx(
            styles.subBlock,
            styles.subBlock__right,
            styles.filterInput,
            inputValues.type === 'NO_ROUTE' && styles.notVisible
          )}>
            <input
              value={routesValues?.toString() || ''}
              onChange={handleInputChange}
              className={data && data?.routes?.changed ? styles.changed : ''}
              name='routes'
              type='text'
              disabled={true}
              placeholder=' '
            />
            <label>Маршрут</label>
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_right)}>
          <div className={clsx(
            styles.subBlock,
            styles.subBlock__right,
            styles.filterInput,
            inputValues.type === 'ON_ROUTE' && styles.notVisible
          )}>
            <input
              value={inputValues?.routesExt || ''}
              onChange={handleChangeRoutes}
              className={data && data?.routes?.changed ? styles.changed : ''}
              name='routesExt'
              type='text'
              disabled={!editVacancy}
              placeholder=' '
            />
            <label>Маршрут</label>
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_left, styles.wrapperMultiselect)}>
          <div className={clsx(styles.wrapper, inputValues.type === 'NO_ROUTE' && styles.notVisible)}>
            <div className='reports__region_block-select'>
              <CustomMultiSelect
                setLoading={() => {
                }}
                setState={() => {
                }}
                action={actionTest}
                reducer={reducerSingleVacancyStatusMultiSelect}
                inputValues={inputValues}
                isShowPlaceholder={true}
                placeholder='Виртуальный супервайзер'
                name='virtualSupervisors'
                pageName='type2'
                options={virtualSupervisorsOptions}
                activeOptions={inputValues.virtualSupervisors}
                resetPages={() => {
                }}
                disabled={true}
                visible={inputValues.type === 'NO_ROUTE'}
                isLongValue={true}
              />
            </div>
            {inputValues?.formData &&
              <span
                className={clsx((resultVirtSupervisors && resultVirtSupervisors.length > 0) && styles.span__elem_active, styles.span__elem, (data && data?.supervisorsExt?.changed) && styles.changed)}>
                {resultVirtSupervisors && resultVirtSupervisors.map((item: { label: string }) => item.label).join(', ')}
              </span>}
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_right, styles.wrapperMultiselect)}>
          <div className={clsx(styles.wrapper, inputValues.type === 'ON_ROUTE' && styles.notVisible)}>
            <div className='reports__region_block-select'>
              <CustomMultiSelect
                setLoading={() => {
                }}
                setState={() => {
                }}
                action={actionTest}
                reducer={reducerSingleVacancyStatusMultiSelect}
                inputValues={inputValues}
                isShowPlaceholder={true}
                placeholder='Виртуальный супервайзер'
                name='virtualSupervisorsExt'
                pageName='type2'
                options={virtualSupervisorsOptions}
                activeOptions={resultVirtSupervisorsExt}
                resetPages={() => {
                }}
                disabled={inputValues.type === 'ON_ROUTE'}
                visible={inputValues.type === 'ON_ROUTE'}
              />
            </div>
            {inputValues?.formData &&
              <div className={styles.multiselectContent}>
                <span
                  className={clsx((resultVirtSupervisorsExt && resultVirtSupervisorsExt.length > 0) && styles.span__elem_active, styles.span__elem, (data && data?.supervisorsExt?.changed) && styles.changed)}>
                  {resultVirtSupervisorsExt && resultVirtSupervisorsExt.map((item: { value: number, label?: string }) => item.label).join(', ')}
                </span>
              </div>}
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_left, styles.wrapperMultiselect)}>
          <div className={clsx(styles.wrapper, inputValues.type === 'NO_ROUTE' && styles.notVisible)}>
            <div className='reports__region_block-select'>
              <CustomMultiSelect
                setLoading={() => {
                }}
                setState={() => {
                }}
                action={actionTest}
                reducer={reducerSingleVacancyStatusMultiSelect}
                inputValues={inputValues}
                isShowPlaceholder={true}
                placeholder='Супервайзер'
                name='supervisors'
                pageName='vacancy'
                options={supervisorsOptions}
                activeOptions={resultsupervisors}
                resetPages={() => {
                }}
                disabled={true}
                visible={inputValues.type === 'NO_ROUTE'}
              />
            </div>
            {inputValues?.formData &&
              <span
                className={clsx((resultsupervisors && resultsupervisors.length > 0) && styles.span__elem_active, styles.span__elem, (data && data?.supervisors?.changed) && styles.changed)}>
                {resultsupervisors && resultsupervisors.map((item: { label: string }) => item.label).join(', ')}
              </span>}
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_right, styles.wrapperMultiselect)}>
          <div className={clsx(styles.wrapper, inputValues.type === 'ON_ROUTE' && styles.notVisible)}>
            <div className='reports__region_block-select'>
              <CustomMultiSelect
                setLoading={() => {
                }}
                setState={() => {
                }}
                action={actionTest}
                reducer={reducerSingleVacancyStatusMultiSelect}
                inputValues={inputValues}
                isShowPlaceholder={true}
                placeholder='Супервайзер'
                name='supervisorsExt'
                pageName='type2'
                options={supervisorsOptions}
                activeOptions={inputValues.supervisorsExt}
                resetPages={() => {
                }}
                disabled={editVacancy ? inputValues.type === 'ON_ROUTE' : true}
                visible={inputValues.type === 'ON_ROUTE'}
              />
            </div>

            {inputValues?.formData &&
              <span
                className={clsx((resultsupervisorsExt && resultsupervisorsExt.length > 0) && styles.span__elem_active, styles.span__elem, (data && data?.supervisors?.changed) && styles.changed)}>
                {resultsupervisorsExt && resultsupervisorsExt.map((item: { value: number, label?: string }) => item.label).join(', ')}
              </span>}
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_left, styles.wrapperMultiselect)}>
          <div className={clsx(styles.wrapper, inputValues.type !== 'ON_ROUTE' && styles.notVisible)}>
            <div className='reports__region_block-select'>
              <CustomMultiSelect
                setLoading={() => {
                }}
                setState={() => {
                }}
                action={actionTest}
                reducer={reducerSingleVacancyStatusMultiSelect}
                inputValues={inputValues}
                isShowPlaceholder={true}
                placeholder='Руководитель проекта'
                name='pm'
                pageName='type2'
                options={managersOptions}
                resetPages={() => {
                }}
                disabled={true}
                visible={inputValues.type === 'NO_ROUTE'}
                activeOptions={inputValues.pm}
              />
            </div>
            {inputValues?.formData &&
              <span
                className={clsx((inputValues?.pm && inputValues?.pm?.length > 0) && styles.span__elem_active, styles.span__elem, (data && data?.projects?.changed) && styles.changed)}>
                {inputValues.pm && inputValues?.pm?.map((item: Item) => item.name).join(', ')}
              </span>}
          </div>      </div>
        <div className={clsx(styles.section__container, styles.section__container_right, styles.wrapperMultiselect)}>
          <div className={clsx(styles.wrapper, inputValues.type === 'ON_ROUTE' && styles.notVisible)}>
            <div className='reports__region_block-select'>
              <CustomMultiSelect
                setLoading={() => {
                }}
                setState={() => {
                }}
                action={actionTest}
                reducer={reducerSingleVacancyStatusMultiSelect}
                inputValues={inputValues}
                isShowPlaceholder={true}
                placeholder='Руководитель проекта'
                name='pm'
                pageName='type2'
                options={managersOptions}
                resetPages={() => {
                }}
                disabled={true}
                visible={inputValues.type === 'ON_ROUTE'}
                activeOptions={inputValues.projects}
              />
            </div>
            {inputValues?.formData &&
              <span
                className={clsx((inputValues?.pm && inputValues?.pm?.length > 0) && styles.span__elem_active, styles.span__elem, (data && data?.projects?.changed) && styles.changed)}>
                {inputValues.pm && inputValues?.pm?.map((item: Item) => item.name).join(', ')}
              </span>}
          </div>
        </div>
      </div>
      <div className={styles.section}>
        <div className={clsx(styles.section__container, styles.section__container_left)}>
          <span className='section__title inside'>Описание из маршрута</span>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_right)}>
          <span className='section__title inside'>Описание</span>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_left)}>
          <div className={clsx(
            styles.subBlock,
            styles.subBlock__right,
            styles.filterInput,
            styles.long,
            inputValues.type === 'NO_ROUTE' && styles.notVisible
          )}>
            <input
              value={formatHistoryDateTime(inputValues?.modifiedDate?.value) || ''}
              name='modifiedDate'
              type='text'
              disabled={true}
              placeholder=' '
            />
            <label>Дата изменения вакансии</label>
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_right)}>
          <div className={clsx(
            styles.subBlock,
            styles.subBlock__right,
            styles.filterInput,
            styles.long,
            inputValues.type !== 'NO_ROUTE' && styles.notVisible
          )}>
            <input
              value={formatHistoryDateTime(inputValues?.modifiedDate?.value) || ''}
              name='modifiedDate'
              type='text'
              disabled={true}
              placeholder=' '
            />
            <label>Дата изменения вакансии</label>
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_left)}>
          <div className={clsx(
            styles.subBlock,
            styles.subBlock__right,
            styles.filterInput,
            inputValues.type === 'NO_ROUTE' && styles.notVisible
          )}>
            <input
              value={inputValues.salary || ''}
              className={data && data?.salary?.changed ? styles.changed : ''}
              name='salary'
              type='text'
              disabled={true}
              placeholder=' '
            />
            <label>Зарплата</label>
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_right)}>
          <NumberInput
            inputValues={inputValues}
            handleInputChange={handleInputChange}
            name='salaryExt'
            title='Зарплата'
            editVacancy={editVacancy}
            data={data}
            reducer={reducerSingleVacancySalary}
          />
        </div>
        <div className={clsx(styles.section__container, styles.section__container_left)}>
          <div className={clsx(
            styles.subBlock,
            styles.subBlock__right,
            styles.filterInput,
            inputValues.type === 'NO_ROUTE' && styles.notVisible
          )}>
            <input
              value={inputValues.revenue || ''}
              className={data && data?.revenue?.changed ? styles.changed : ''}
              name='revenue'
              type='text'
              disabled={true}
              placeholder=' '
            />
            <label>Выручка</label>
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_right)}>
          <NumberInput
            inputValues={inputValues}
            handleInputChange={handleInputChange}
            name='revenueExt'
            title='Выручка'
            editVacancy={editVacancy}
            data={data}
            reducer={reducerSingleVacancySalary}
          />
        </div>
        <div className={clsx(styles.section__container, styles.section__container_left)}>
          <div className={clsx(
            styles.subBlock,
            styles.filterInput,
            inputValues.type === 'NO_ROUTE' && styles.notVisible
          )}>
            <div className={clsx(styles.subBlock__right, styles.subBlock__right_select)}>
              <Select
                disabled={!editVacancy}
                value={statusName}
                isShowPlaceholder={true}
                propsChange={(event: IVacancyEventItem) =>
                  selectChange(event, 'status')
                }
                options={inputValues?.formData?.status.map((el: { [key: string]: string }) => ({
                  value: Object.keys(el),
                  label: Object.values(el),
                }))}
                className={clsx(styles.filterSelect, (data && data?.status?.changed) ? styles.changed : '')}
                placeholder={statusName || 'Выбрать'}
                name='status'
                span='Статус вакансии'
              />
            </div>
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_right)}>
          <div className={clsx(
            styles.subBlock,
            styles.filterInput,
            inputValues.type !== 'NO_ROUTE' && styles.notVisible
          )}>
            <div className={clsx(styles.subBlock__right, styles.subBlock__right_select)}>
              <Select
                disabled={!editVacancy}
                value={inputValues.type === 'NO_ROUTE' && statusName}
                propsChange={(event: IVacancyEventItem) =>
                  selectChange(event, 'status')
                }
                options={inputValues?.formData?.status.map((el: { [key: string]: string }) => ({
                  value: Object.keys(el),
                  label: Object.values(el),
                }))}
                className={clsx(styles.filterSelect, (statusName && data && data?.status?.changed) && styles.changed)}
                placeholder={statusName || 'Выбрать'}
                name='status'
                span='Статус вакансии'
                isShowPlaceholder={true}
              />
            </div>
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_left, styles.wrapperMultiselect)}>
          <div className={clsx(styles.wrapper, inputValues.type === 'NO_ROUTE' && styles.notVisible)}>
            <div className='reports__region_block-select'>
              <CustomMultiSelect
                setLoading={() => {
                }}
                setState={() => {
                }}
                action={actionTest}
                reducer={reducerSingleVacancyStatusMultiSelect}
                inputValues={inputValues}
                isShowPlaceholder={true}
                placeholder='Регион'
                name='regions'
                pageName='vacancy'
                options={regionsOptions}
                activeOptions={matchingRegions}
                resetPages={() => {
                }}
                disabled={true}
                visible={inputValues.type === 'NO_ROUTE'}
              />
            </div>
            {inputValues?.formData &&
              <span
                className={clsx((matchingRegions && matchingRegions.length > 0) && styles.span__elem_active, styles.span__elem, (data && data?.regions?.changed) && styles.changed)}>
                {matchingRegions && matchingRegions.map((item: Item) => item.name).join(', ')}
              </span>}
          </div>

        </div>
        <div className={clsx(styles.section__container, styles.section__container_right, styles.wrapperMultiselect)}>
          <div className={clsx(styles.wrapper, inputValues.type === 'ON_ROUTE' && styles.notVisible)}>
            <div className='reports__region_block-select'>
              <CustomMultiSelect
                setLoading={() => {
                }}
                setState={() => {
                }}
                reducer={reducerSingleVacancyStatusMultiSelect}
                inputValues={inputValues}
                isShowPlaceholder={true}
                placeholder='Регион'
                name='regionsExt'
                pageName='type2'
                options={regionsOptions}
                action={actionTest}
                activeOptions={inputValues.regionsExt}
                resetPages={() => {
                }}
                disabled={!editVacancy || (inputValues.areasExt !== undefined && inputValues?.areasExt?.length !== 0)}
                visible={inputValues.type === 'ON_ROUTE'}
              />
            </div>
            {inputValues?.formData &&
              <span
                className={clsx((matchingRegionsExt && matchingRegionsExt.length > 0) && styles.span__elem_active, styles.span__elem, (data && data?.regions?.changed) && styles.changed)}>
                {matchingRegionsExt && matchingRegionsExt.map((item: { value: number, label?: string }) => item.label).join(', ')}
              </span>}
          </div>

        </div>
        <div className={clsx(styles.section__container, styles.section__container_left, styles.wrapperMultiselect)}>
          <div className={clsx(styles.wrapper, inputValues?.type === 'NO_ROUTE' && styles.notVisible)}>
            <div className='reports__region_block-select'>
              <CustomMultiSelect
                setLoading={() => { }}
                setState={() => { }}
                action={() => { }}
                reducer={() => { }}
                inputValues={inputValues}
                isShowPlaceholder={true}
                placeholder='Область'
                name='areas'
                pageName='vacancy'
                options={data?.formData?.areas}
                activeOptions={matchingAreas}
                resetPages={() => { }}
                disabled={true}
                visible={inputValues?.type === 'NO_ROUTE'}
              />
            </div>
            <div>
              {inputValues?.formData &&
                <span
                  className={clsx((matchingAreas && matchingAreas.length > 0) && styles.span__elem_active, styles.span__elem, (data && data?.areas?.changed) && styles.changed)}>
                  {matchingAreas && matchingAreas.map((item: Item) => item.name).join(', ')}
                </span>}
            </div>
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_right, styles.wrapperMultiselect)}>
          <div className={clsx(styles.wrapper, inputValues.type === 'ON_ROUTE' && styles.notVisible)}>
            <div className='reports__region_block-select'>
              <CustomMultiSelect
                setLoading={() => {
                }}
                setState={() => {
                }}
                action={actionTest}
                reducer={reducerSingleVacancyStatusMultiSelect}
                inputValues={inputValues}
                isShowPlaceholder={true}
                placeholder='Область'
                name='areasExt'
                pageName='type2'
                options={areasOptions}
                activeOptions={inputValues.areasExt}
                resetPages={() => {
                }}
                disabled={editVacancy ? areasOptions?.length === 0 : true}
                visible={inputValues.type === 'ON_ROUTE'}
              />
            </div>

            {inputValues?.formData &&
              <span
                className={clsx((matchingAreasExt && matchingAreasExt.length > 0) && styles.span__elem_active, styles.span__elem, (data && data?.areas?.changed) && styles.changed)}>
                {matchingAreasExt && matchingAreasExt?.map((item: { value: number, label?: string }) => item.label).join(', ')}
              </span>}
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_left)}>
          <div className={clsx(
            styles.subBlock,
            styles.subBlock__right,
            styles.filterInput,
            inputValues.type === 'NO_ROUTE' && styles.notVisible
          )}>
            <input
              value={inputValues?.cities?.join(', ') || ''}
              className={(data && data?.cities?.changed) ? styles.changed : ''}
              placeholder=' '
              name='cities'
              type='text'
              disabled={true}
            />
            <label>Город</label>
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_right)}>
          <div className={clsx(
            styles.subBlock,
            styles.subBlock__right,
            styles.filterInput,
            inputValues.type === 'ON_ROUTE' && styles.notVisible
          )}>
            <input
              value={inputValues.citiesExt || ''}
              className={(data && data?.cities?.changed) ? styles.changed : ''}
              onChange={handleInputChange}
              name='citiesExt'
              type='text'
              disabled={editVacancy ? inputValues.type === 'ON_ROUTE' : true}
              placeholder=' '
            />
            <label>Город</label>
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_left)}>
          <div className={clsx(
            styles.subBlock,
            styles.subBlock__right,
            styles.filterInput,
            inputValues.type === 'NO_ROUTE' && styles.notVisible
          )}>
            <input
              value={inputValues?.subway || ''}
              onChange={handleInputChange}
              className={data && data?.subway?.changed ? styles.changed : ''}
              placeholder=' '
              name='subway'
              type='text'
              disabled={!editVacancy}
            />
            <label>Метро/Район</label>
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_right)}>
          <div className={clsx(
            styles.subBlock,
            styles.subBlock__right,
            styles.filterInput,
            inputValues.type !== 'NO_ROUTE' && styles.notVisible
          )}>
            <input
              value={(inputValues.type === 'NO_ROUTE' && inputValues.subway) || ''}
              className={data && data?.subway?.changed ? styles.changed : ''}
              onChange={handleInputChange}
              name='subway'
              type='text'
              disabled={editVacancy ? inputValues.type === 'ON_ROUTE' : true}
              placeholder=' '
            />
            <label>Метро/Район</label>
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_left)}>
          <div className={styles.history_title}>
            <TextArea
              inputValues={inputValues}
              handleInputChange={handleInputChange}
              name='merchs'
              title='Логин/Локация'
              editVacancy={editVacancy}
              data={data}
              notVisible={inputValues.type === 'NO_ROUTE'}
              isDisabled={true}
            />
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_right)}>
          <div className={styles.history_title}>
            <TextArea
              inputValues={inputValues}
              handleInputChange={handleInputChange}
              name='merchsExt'
              title='Логин/Локация'
              editVacancy={editVacancy}
              data={data}
              notVisible={inputValues.type === 'ON_ROUTE'}
              isDisabled={editVacancy ? inputValues.type === 'ON_ROUTE' : true}
            />
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_left)}>
          <div className={clsx(
            styles.subBlock,
            styles.subBlock__right,
            styles.filterInput,
            styles.long,
            inputValues.type === 'NO_ROUTE' && styles.notVisible
          )}>
            <input
              value={inputValues.name || ''}
              onChange={handleInputChange}
              className={data && data?.name?.changed ? styles.changed : ''}
              name='name'
              type='text'
              disabled={editVacancy ? inputValues.type !== 'LOST_ROUTE' : true}
              placeholder=' '
            />
            <label>Название вакансии</label>
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_right)}>
          <div className={clsx(
            styles.subBlock,
            styles.subBlock__right,
            styles.filterInput,
            styles.long,
            inputValues.type !== 'NO_ROUTE' && styles.notVisible
          )}>
            <input
              defaultValue={(inputValues.type === 'NO_ROUTE' && inputValues.name) || ''}
              className={data && data?.name?.changed ? styles.changed : ''}
              onChange={handleInputChange}
              name='name'
              type='text'
              disabled={editVacancy ? inputValues.type === 'ON_ROUTE' : true}
              placeholder=' '
            />
            <label>Название вакансии</label>
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_left)}>
          <div className={clsx(
            styles.subBlock,
            styles.subBlock__right,
            styles.filterInput,
            inputValues.type === 'NO_ROUTE' && styles.notVisible
          )}>
            <input
              value={(inputValues?.createdDate && formatHistoryDateTime(inputValues?.createdDate)) || ''}
              name='dateInputFormat'
              type='text'
              disabled={true}
              placeholder=' '
            />
            <label>Дата создания</label>
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_right)}>
          <div
            className={clsx(
              styles.subBlock,
              styles.subBlock__right,
              styles.filterInput,
              inputValues.type !== 'NO_ROUTE' && styles.notVisible
            )}>
            <input
              value={(inputValues.type === 'NO_ROUTE' && (inputValues?.createdDate && formatHistoryDateTime(inputValues?.createdDate))) || ''}
              name='dateInputFormat'
              type='text'
              disabled={true}
              placeholder=' '
            />
            <label>Дата создания</label>
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_left)}>
          <div className={clsx(
            styles.subBlock,
            styles.filterInput,
            inputValues.type === 'NO_ROUTE' && styles.notVisible
          )}>
            <div className={clsx(styles.subBlock__right, styles.subBlock__right_select)}>
              <Select
                disabled={true}
                value={inputValues?.schedule && Object.values(inputValues?.schedule)[0]}
                isShowPlaceholder={true}
                propsChange={(event: IVacancyEventItem) =>
                  selectChange(event, 'schedule')
                }
                options={inputValues?.formData?.schedule.map((el: { [key: string]: string }) => ({
                  value: Object.keys(el),
                  label: Object.values(el),
                }))}
                className={clsx(styles.filterSelect, (data && data?.schedule?.changed) && styles.changed)}
                placeholder={(inputValues.schedule && Object.values(inputValues.schedule)[0]) || 'Выбрать'}
                name={'schedule'}
                span='График'
              />
            </div>
          </div>
        </div>

        <div className={clsx(styles.section__container, styles.section__container_right)}>
          <div className={clsx(
            styles.subBlock,
            styles.filterInput
          )}>
            <div className={clsx(styles.subBlock__right, styles.subBlock__right_select)}>
              <Select
                disabled={!editVacancy}
                value={scheduleExtSelect}
                propsChange={(event: IVacancyEventItem) =>
                  selectChange(event, 'scheduleExt')
                }
                options={inputValues?.formData?.schedule.map((el: { [key: string]: string }) => ({
                  value: Object.keys(el),
                  label: Object.values(el),
                }))}
                className={clsx(styles.filterSelect, (scheduleExtSelect && data && data?.schedule?.changed) && styles.changed)}
                placeholder={scheduleExtSelect || 'Выбрать'}
                name='scheduleExt'
                span='График'
                isShowPlaceholder={true}
              />
            </div>
          </div>
        </div>

        <div className={clsx(styles.section__container, styles.section__container_left)}>
          <div className={clsx(
            styles.subBlock,
            styles.subBlock__right,
            styles.filterInput,
            styles.long,
            inputValues.type === 'NO_ROUTE' && styles.notVisible
          )}>
            <input
              value={inputValues.weekTiming || 0}
              className={data && data?.weekTiming?.changed ? styles.changed : ''}
              name='weekTiming'
              type='text'
              disabled={true}
              placeholder=' '
            />
            <label>Договорное время за неделю</label>
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_right)}>
          <NumberInput
            inputValues={inputValues}
            handleInputChange={handleInputChange}
            name='weekTimingExt'
            title='Договорное время за неделю'
            editVacancy={editVacancy}
            data={data}
            reducer={reducerSingleVacancyWeekTiming}
          />
        </div>

        
        <div className={clsx(styles.section__container, styles.section__container_left, styles.wrapperMultiselect)}>
          <div className={clsx(styles.wrapper, inputValues.type === 'NO_ROUTE' && styles.notVisible)}>
            <div className='reports__region_block-select'>
              <CustomMultiSelect
                setLoading={() => { }}
                setState={() => { }}
                action={actionTest}
                reducer={() => { }}
                inputValues={inputValues}
                isShowPlaceholder={true}
                placeholder='Дни недели'
                name='days'
                pageName='days'
                options={daysOptions}
                activeOptions={matchingDays}
                resetPages={() => { }}
                disabled={true}
                visible={inputValues.type === 'NO_ROUTE'}
              />
            </div>
            {inputValues?.formData &&
              <span
                className={clsx((matchingDays && matchingDays.length > 0) && styles.span__elem_active, styles.span__elem, (data && data?.contracts?.changed) && styles.changed)}>
                {matchingDays && matchingDays.map((item: { label: string }) => item.label).join(', ')}
              </span>}
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_right, styles.wrapperMultiselect)}>
          <div className={clsx(styles.wrapper, inputValues.type === 'ON_ROUTE' && styles.notVisible)}>
            <div className='reports__region_block-select'>
              <CustomMultiSelect
                setLoading={() => {
                }}
                setState={() => { }}
                action={actionTest}
                reducer={reducerSingleVacancyStatusMultiSelect}
                inputValues={inputValues}
                isShowPlaceholder={true}
                placeholder='Дни недели'
                name='daysExt'
                pageName='days'
                options={daysOptions}
                activeOptions={matchingDaysExt}
                resetPages={() => { }}
                disabled={!editVacancy}
                visible={inputValues.type === 'ON_ROUTE'}
              />
            </div>
            {inputValues?.formData &&
              <span
                className={clsx((matchingDaysExt && matchingDaysExt.length > 0) && styles.span__elem_active, styles.span__elem, (data && data?.contracts?.changed) && styles.changed)}>
                {matchingDaysExt && matchingDaysExt.map((item: { label: string }) => item.label).join(', ')}
              </span>}
          </div>

        </div>
        <div className={clsx(styles.section__container, styles.section__container_left)}>
          <div className={clsx(
            styles.subBlock,
            styles.subBlock__right,
            styles.filterInput,
            inputValues.type === 'NO_ROUTE' && styles.notVisible
          )}>
            <input
              value={inputValues.posCount || ''}
              className={data && data?.posCount?.changed ? styles.changed : ''}
              name='posCount'
              type='number'
              disabled={true}
              placeholder=' '
            />
            <label>Количество ТТ</label>
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_right)}>
          <div className={clsx(
            styles.subBlock,
            styles.subBlock__right,
            styles.filterInput,
            inputValues.type === 'ON_ROUTE' && styles.notVisible
          )}>
            <input
              value={inputValues.posCountExt || ''}
              onChange={handleInputChange}
              name='posCountExt'
              type='number'
              disabled={editVacancy ? inputValues.type === 'ON_ROUTE' : true}
              className={data && data?.posCount?.changed ? styles.changed : ''}
              placeholder=' '
            />
            <label>Количество ТТ</label>
          </div>

        </div>
        <div className={clsx(styles.section__container, styles.section__container_left, styles.wrapperMultiselect)}>
          <div className={clsx(styles.wrapper, inputValues.type === 'NO_ROUTE' && styles.notVisible)}>
            <div className='reports__region_block-select'>
              <CustomMultiSelect
                setLoading={() => { }}
                setState={() => { }}
                action={actionTest}
                reducer={() => { }}
                inputValues={inputValues}
                isShowPlaceholder={true}
                placeholder='Контракты'
                name='contracts'
                pageName='vacancy'
                options={contractsOptions}
                activeOptions={matchingContracts}
                resetPages={() => { }}
                disabled={true}
                visible={inputValues.type === 'NO_ROUTE'}
              />
            </div>
            {inputValues?.formData &&
              <span
                className={clsx((matchingContracts && matchingContracts.length > 0) && styles.span__elem_active, styles.span__elem, (data && data?.contracts?.changed) && styles.changed)}>
                {matchingContracts && matchingContracts.map((item: Item) => item.name).join(', ')}
              </span>}
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_right, styles.wrapperMultiselect)}>
          <div className={clsx(styles.wrapper, inputValues.type === 'ON_ROUTE' && styles.notVisible)}>
            <div className='reports__region_block-select'>
              <CustomMultiSelect
                setLoading={() => {
                }}
                setState={() => {
                }}
                action={actionTest}
                reducer={reducerSingleVacancyStatusMultiSelect}
                inputValues={inputValues}
                isShowPlaceholder={true}
                placeholder='Контракты'
                name='contractsExt'
                pageName='type2'
                options={contractsOptions}
                activeOptions={inputValues.contractsExt}
                resetPages={() => {
                }}
                disabled={!editVacancy}
                visible={inputValues.type === 'ON_ROUTE'}
              />
            </div>
            {inputValues?.formData &&
              <span
                className={clsx((matchingContractsExt && matchingContractsExt.length > 0) && styles.span__elem_active, styles.span__elem, (data && data?.contracts?.changed) && styles.changed)}>
                {matchingContractsExt && matchingContractsExt.map((item: { value: number, label?: string }) => item.label).join(', ')}
              </span>}
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_left)}>
          <div className={clsx(
            styles.subBlock,
            styles.subBlock__right,
            styles.filterInput,
            styles.long,
            inputValues.type === 'NO_ROUTE' && styles.notVisible
          )}>
            <input
              value={`${hour}:${minuts}` || ''}
              className={(data && data?.workload?.changed) ? styles.changed : ''}
              name='workload'
              type='text'
              disabled={true}
              placeholder=' '
            />
            <label>Длительность рабочего дня</label>
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_right)}>
          <div className={clsx(
            styles.subBlock,
            styles.subBlock__right,
            styles.filterInput,
            styles.long,
            inputValues.type === 'ON_ROUTE' && styles.notVisible
          )}>
            <input
              value={`${hourExt}:${minutsExt}` || '00:00'}
              onChange={handleInputChange}
              className={(data && data?.workload?.changed) ? (styles.changed, styles.superstyle) : styles.superstyle}
              name='workloadExt'
              type='time'
              placeholder=' '
            />
            <label>Длительность рабочего дня</label>
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_left)}>
          <div className={styles.history_title}>
            <TextArea
              inputValues={inputValues}
              handleInputChange={handleInputChange}
              name='addresses'
              title='Список адресов'
              editVacancy={editVacancy}
              data={data}
              notVisible={inputValues.type === 'NO_ROUTE'}
              isDisabled={true}
            />
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_right)}>
          <div className={styles.history_title}>
            <TextArea
              inputValues={inputValues}
              handleInputChange={handleInputChange}
              name='addressesExt'
              title='Список адресов'
              editVacancy={editVacancy}
              data={data}
              notVisible={inputValues.type === 'ON_ROUTE'}
              isDisabled={editVacancy ? inputValues.type === 'ON_ROUTE' : true}
            />
          </div>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_left)}>
          <TextArea
            inputValues={inputValues}
            handleInputChange={handleInputChange}
            name='description'
            title='Описание'
            editVacancy={editVacancy}
            data={data}
            notVisible={inputValues.type === 'NO_ROUTE'}
            isDisabled={!editVacancy}
          />
        </div>
        <div className={clsx(styles.section__container, styles.section__container_right)}>
          <TextArea
            inputValues={inputValues}
            handleInputChange={handleInputChange}
            name='description'
            title='Описание'
            editVacancy={editVacancy}
            data={data}
            notVisible={inputValues.type !== 'NO_ROUTE'}
            isDisabled={!editVacancy}
          />
        </div>
        <div className={clsx(styles.section__container, styles.section__container_left)}>
          <TextArea
            inputValues={inputValues}
            handleInputChange={handleInputChange}
            name='url'
            title='Ссылка на вакансию'
            editVacancy={editVacancy}
            data={data}
            notVisible={inputValues.type === 'NO_ROUTE'}
            isDisabled={!editVacancy}
          />
        </div>
        <div className={clsx(styles.section__container, styles.section__container_right)}>
          <TextArea
            inputValues={inputValues}
            handleInputChange={handleInputChange}
            name='url'
            title='Ссылка на вакансию'
            editVacancy={editVacancy}
            data={data}
            notVisible={inputValues.type !== 'NO_ROUTE'}
            isDisabled={!editVacancy}
          />
        </div>
      </div>
      <div className={styles.section}>
        <div className={clsx(styles.section__container, styles.section__container_left)}>
          <span className='section__title inside'>Требования к кандидату</span>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_right)}>
          <span className='section__title inside'>Требования к кандидату</span>
        </div>
        <div className={clsx(styles.section__container, styles.section__container_left)}>
          <TextArea
            inputValues={inputValues}
            handleInputChange={handleInputChange}
            name='comment'
            title='Комментарий ОПП'
            editVacancy={editVacancy}
            data={data}
            notVisible={inputValues.type === 'NO_ROUTE'}
            isDisabled={!editVacancy}
          />
        </div>
        <div className={clsx(styles.section__container, styles.section__container_right)}>
          <TextArea
            inputValues={inputValues}
            handleInputChange={handleInputChange}
            name='comment'
            title='Комментарий ОПП'
            editVacancy={editVacancy}
            data={data}
            notVisible={inputValues.type !== 'NO_ROUTE'}
            isDisabled={!editVacancy}
          />
        </div>
      </div>
    </div>
  )
}

export default VacancyBlock;